export const MathUtils = {
  roundToNearestQuarter: (numberToRound: number) => {
    return Number((Math.round(numberToRound * 4) / 4).toFixed(2));
  },
};
